
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.477 2.29h8.601L10.836.796l.508-.43 3.82 3.82v.5l-3.82 3.82-.508-.429 1.258-1.508H3.469l1.258 1.508-.508.43-3.82-3.82v-.5l3.82-3.82.508.429-1.25 1.492zm9.406 1.038H2.68l-.899 1.11.883 1.093h10.227l.89-1.093-.898-1.11z","fill":"currentColor"}})])
          )
        }
      }
    